import Vue from 'vue'
import store from './store'
import Router from 'vue-router'

Vue.use(Router)

// TODO : Set meta auth and check in beforeEach

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: require('../views/Login.vue').default,
      beforeEnter (to, from, next) {
        delete Vue.prototype.$http.defaults.headers.common.Authorization
        if (store.state.user.token) {
          store.commit('LOGOFF')
        } else {
          next()
        }
      },
    },
    {
      path: '/password',
      name: 'password',
      component: require('../views/Password.vue').default,
      beforeEnter (to, from, next) {
        if (to.query.token) {
          Vue.prototype.$http.defaults.headers.common.Authorization = 'Bearer ' + to.query.token
          next()
        } else {
          next('/')
        }
      },
    },
    {
      path: '/home',
      name: 'home',
      component: require('../views/Home.vue').default,
      beforeEnter (to, from, next) {
        if (store.state.user.token) {
          next()
        } else {
          next('/')
        }
      },
    },
    {
      path: '/account',
      name: 'account',
      component: require('../views/Account.vue').default,
      beforeEnter (to, from, next) {
        if (store.state.user.token) {
          next()
        } else {
          next('/')
        }
      },
    },
    {
      path: '/maintenance',
      name: 'maintenance',
      component: require('../views/Maintenance.vue').default,
      beforeEnter (to, from, next) {
        if (store.state.maintenance) {
          next()
        } else {
          next('/')
        }
      },
    },
    { path: '*', redirect: '/' },
  ],
})

router.beforeEach((to, from, next) => {
  if (store.state.alert.show) {
    store.dispatch('setAlert', { bool: false, type: 'error', text: '' })
  }
  next()
})

export default router
